import { useSelector } from "react-redux";
import AppStateInterface from "../../interfaces/AppStateInterface";

export const useCurrentSection = () => {
  return useSelector<AppStateInterface, AppStateInterface["currentSection"]>(
    (state) => state.currentSection,
  );
};
